import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const CuratedButtonGroupStyles = styled.div`
  background-color: ${Colors.primary.claytonBlue.standard};
  min-height: 220px;
  padding-bottom: 20px;
  padding-top: 40px;

  .curated-button-group {
    max-width: 1100px;
    margin: auto;
  }

  .curated-button-group-heading {
    color: ${Colors.primary.white.standard};
    font-weight: 700;
    text-align: center;
  }

  .curated-button-group-heading {
    margin-left: 10px;
    margin-bottom: 20px;
  }

  .curated-button {
    display: none;
    margin: auto;
    max-width: 270px;
    width: 100%;
  }

  .carousel-root .carousel.carousel-slider .control-arrow,
  .carousel-root .carousel.carousel-slider .control-arrow:hover,
  .carousel-root .carousel.carousel-slider .control-arrow:active {
    background-color: transparent;
    box-shadow: none;
    filter: invert(1);
    top: calc(50%);
    transform: translateY(-50%);
  }

  .carousel-root .carousel.carousel-slider .control-next {
    right: -40px;
  }

  .carousel-root .carousel.carousel-slider .control-prev {
    left: -40px;
  }

  .slider-wrapper .slider .slide {
    background-color: transparent;
  }

  .slideshow {
    margin: auto;
    max-width: 270px;
    width: 90%;

    .curated-button {
      display: flex;
    }
  }

  @media screen and (min-width: 400px) {
    .carousel-root .carousel.carousel-slider .control-next {
      right: -50px;
    }

    .carousel-root .carousel.carousel-slider .control-prev {
      left: -50px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .slideshow {
      display: none;
    }

    .curated-button {
      display: flex;
      width: calc(25% - 20px);
    }

    .curated-buttons:not(.full-row) {
      justify-content: center;

      .curated-button {
        margin: 0 15px;
        width: 270px;
      }
    }

    .curated-button-group-heading {
      text-align: left;
    }

    .curated-buttons {
      align-items: flex-start;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    }
  }
`;
